import axiosClient from './axiosClient';

const deliveryApi = {
  // Administracion de distritos de Lima con costo de delivery (solo administrador)
  getDeliveryDistricts: () => axiosClient.get('/delivery-districts'),
  createDeliveryDistrict: (data) => axiosClient.post('/delivery-districts', data),
  updateDeliveryDistrict: (id, data) => axiosClient.put(`/delivery-districts/${id}`, data),
  deleteDeliveryDistrict: (id) => axiosClient.delete(`/delivery-districts/${id}`),

  // Listado publico de distritos activos, usado por el paso "Envio" del checkout
  getActiveDeliveryDistricts: () => axiosClient.get('/catalog/delivery-districts'),
};

export default deliveryApi;
